import { render, staticRenderFns } from "./VidyoChatContainer.vue?vue&type=template&id=42bafa65&"
import script from "./VidyoChatContainer.vue?vue&type=script&lang=js&"
export * from "./VidyoChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./VidyoChatContainer.vue?vue&type=style&index=0&id=42bafa65&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports